(function () {
  const CLOSE_DELAY = 200;
  // Pointer-rest detection — see the block below.
  const SETTLE_INTERVAL = 100;
  const SETTLE_SLOP = 10;

  const header = document.querySelector('.section-header .header') || document.querySelector('.header');
  if (!header) return;

  // ---- Touch two-tap gating (AAS-4696) ----
  // The desktop nav opens purely on :hover, but a touch device has no resting
  // hover — a tap on an L1 <a href> just navigates, so the mega panel can never
  // be seen. Below we give touch the standard two-tap (first tap opens, second
  // follows the link). Which mode runs is decided per interaction, not once:
  //   - desktopMQ: the inline nav only exists >=1024px; below that the burger
  //     drawer owns navigation, so the two-tap must stay off there.
  //   - coarseMQ: a touch-primary device (real tablet, DevTools emulation)
  //     reports (hover: none) / (pointer: coarse) — the reliable signal.
  //   - lastPointerType: catches a touch tap on a HYBRID laptop whose primary
  //     pointer is a mouse (coarseMQ stays false there), while that same user's
  //     mouse interactions keep instant hover-nav.
  const desktopMQ = window.matchMedia('(min-width: 1024px)');
  const coarseMQ = window.matchMedia('(hover: none), (pointer: coarse)');
  let lastPointerType = 'mouse';
  window.addEventListener(
    'pointerdown',
    function (e) {
      if (e.pointerType) lastPointerType = e.pointerType;
    },
    true
  );
  // A touch-primary interaction, regardless of where in the header it lands.
  function isCoarsePointer() {
    return coarseMQ.matches || lastPointerType === 'touch' || lastPointerType === 'pen';
  }

  // ...and the same thing narrowed to where the two-tap nav actually applies.
  function isTouchNav() {
    return desktopMQ.matches && isCoarsePointer();
  }


  // ---- Pointer rest, the single trigger for both (AAS-5658) ----
  // Two things used to fire the instant the cursor touched the header: the
  // flyout, and — on a transparent hero header — the whole chrome flipping to
  // solid white (background, link colour, logo filter, icon layers). A pointer
  // merely on its way to the browser's Back button set both off, and the chrome
  // is the worse of the two because its selector spans the ENTIRE header, so
  // even a pass over the logo repaints the hero.
  //
  // A fixed dwell (atomic runs 120 ms) filters a quick transit but not a slow
  // one — a hesitant sweep still sits still long enough on the way past. So the
  // trigger is not elapsed time but STILLNESS: we sample the pointer every
  // SETTLE_INTERVAL and arm only once it has moved less than SETTLE_SLOP between
  // two samples. A pointer in transit is always moving, however unhurried; a
  // pointer that has arrived stops. SETTLE_SLOP/SETTLE_INTERVAL is 100 px/s —
  // an order of magnitude under any real transit, and no one crosses a header
  // that slowly on purpose. (Same principle as the jQuery hoverIntent plugin.)
  //
  // :hover cannot be deferred, hence the stamped class. Every paired rule reads
  // it (sections/header.liquid, component-mega-menu.css,
  // component-menu-drawer.css); `.is-pointer-rested` has the same specificity as
  // the `:hover` it replaced, so nothing moved in the cascade.
  const REST_CLASS = 'is-pointer-rested';
  let pointerInHeader = false;
  let pointerX = 0;
  let pointerY = 0;
  let sampleX = 0;
  let sampleY = 0;
  let settleTimer = null;
  // The L1 the cursor is inside right now, if any. Rest anywhere else on the
  // header (logo, icons, empty space) lifts the chrome and opens no panel.
  let hoveredItem = null;

  function cancelSettle() {
    if (settleTimer) {
      clearTimeout(settleTimer);
      settleTimer = null;
    }
  }

  function onSettled() {
    header.classList.add(REST_CLASS);
    if (hoveredItem && !isTouchNav()) setActive(hoveredItem);
  }

  function pollSettle() {
    settleTimer = null;
    if (Math.abs(pointerX - sampleX) + Math.abs(pointerY - sampleY) <= SETTLE_SLOP) {
      onSettled();
      return;
    }
    sampleX = pointerX;
    sampleY = pointerY;
    settleTimer = window.setTimeout(pollSettle, SETTLE_INTERVAL);
  }

  // Re-arm from a known position. Called on entering the header and again on
  // entering an L1, so a cursor that rested on the logo and then moved onto a
  // menu item has to come to rest a second time before the panel opens.
  function armSettle(x, y) {
    cancelSettle();
    pointerX = sampleX = x;
    pointerY = sampleY = y;
    settleTimer = window.setTimeout(pollSettle, SETTLE_INTERVAL);
  }

  // The chrome is dropped only when nothing still needs it. An open panel does:
  // .has-mega-open paints the header solid for the whole close hold, so handing
  // the transparent treatment back the moment the cursor leaves would put white
  // icons on a white bar — the layered icons (search, cart, account, wishlist)
  // cross-fade on opacity, which no colour override can reach. closeAll()
  // releases the stamp once the panel is actually gone.
  function dropRest() {
    cancelSettle();
    if (activeItem) return;
    header.classList.remove(REST_CLASS);
  }

  // Called from closeAll: the panel that was holding the stamp has gone, so the
  // stamp goes too — unless the pointer or keyboard focus is still in the
  // header, in which case it was never the panel's to release.
  function releaseRestIfIdle() {
    if (pointerInHeader) return;
    if (header.contains(document.activeElement) && isKeyboardFocus(document.activeElement)) return;
    header.classList.remove(REST_CLASS);
  }

  header.addEventListener('mousemove', function (e) {
    pointerX = e.clientX;
    pointerY = e.clientY;
  });

  header.addEventListener('mouseenter', function (e) {
    pointerInHeader = true;
    // Touch stamps instantly: a tap is explicit, has no transit to filter, and
    // the solid header is what keeps the nav legible once a panel is open.
    if (isCoarsePointer()) {
      cancelSettle();
      header.classList.add(REST_CLASS);
      return;
    }
    armSettle(e.clientX, e.clientY);
  });

  header.addEventListener('mouseleave', function () {
    pointerInHeader = false;
    hoveredItem = null;
    dropRest();
  });

  // Keyboard never rests a pointer, so tabbing into the nav on a transparent
  // header would leave white links on white. The chrome follows focus too.
  header.addEventListener('focusin', function (e) {
    if (e.target && typeof e.target.matches === 'function') {
      try {
        if (!e.target.matches(':focus-visible')) return;
      } catch (err) {
        /* no :focus-visible support — treat any focus as keyboard focus */
      }
    }
    cancelSettle();
    header.classList.add(REST_CLASS);
  });

  header.addEventListener('focusout', function (e) {
    if (e.relatedTarget && header.contains(e.relatedTarget)) return;
    dropRest();
  });

  // Not an early return on an empty list: the chrome above must keep working on
  // a header whose menu has no flyouts at all. Every items.forEach below simply
  // wires nothing.
  const items = header.querySelectorAll('.list-menu__has-mega');

  let activeItem = null;
  let closeTimer = null;

  // The L1 pinned open by a tap (kept separate from activeItem so the outside-tap
  // listener only ever acts on a touch-opened panel, never a hover/keyboard one).
  let tapOpenItem = null;
  function closeTapFlyout() {
    if (!tapOpenItem) return;
    closeAll();
    tapOpenItem = null;
  }

  function cancelClose() {
    if (closeTimer) {
      clearTimeout(closeTimer);
      closeTimer = null;
    }
  }

  function scheduleClose() {
    cancelClose();
    // Nothing open means nothing to close. Arming anyway used to leave a live
    // closeTimer behind after the cursor merely crossed an L1 — and a live
    // closeTimer reads as "the user is in the menu", which handed the NEXT L1
    // an instant open. A sweep across two L1s opened the second one outright.
    if (!activeItem) return;
    closeTimer = window.setTimeout(closeAll, CLOSE_DELAY);
  }

  // Keep the L1 trigger's aria-expanded in step with the panel (AAS-4696). The
  // markup ships aria-expanded="false" but the hover system never updated it, so
  // the panel's state was invisible to screen readers — now doubly relevant with
  // the trigger being tap-interactive.
  function setExpanded(item, expanded) {
    if (!item) return;
    const link = item.querySelector('.header__menu-item');
    if (link) link.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  }

  function closeAll() {
    if (activeItem) {
      setExpanded(activeItem, false);
      activeItem.classList.remove('is-mega-open');
      activeItem = null;
    }
    if (header) header.classList.remove('has-mega-open');
    document.body.classList.remove('has-mega-open');
    closeTimer = null;
    releaseRestIfIdle();
  }

  function setActive(newItem) {
    cancelClose();
    // An explicit open (keyboard, tap, an L1 swap) supersedes a rest still
    // being waited on, so it cannot land afterwards on a stale item.
    cancelSettle();
    if (activeItem === newItem) return;

    const oldItem = activeItem;

    if (oldItem && newItem) {
      // Swap between L1s — kill transition for one frame so the swap is instant
      const oldMega = oldItem.querySelector('.mega-menu__content');
      const newMega = newItem.querySelector('.mega-menu__content');
      if (oldMega) oldMega.style.transition = 'none';
      if (newMega) newMega.style.transition = 'none';

      oldItem.classList.remove('is-mega-open');
      newItem.classList.add('is-mega-open');
      setExpanded(oldItem, false);
      setExpanded(newItem, true);

      requestAnimationFrame(function () {
        if (oldMega) oldMega.style.transition = '';
        if (newMega) newMega.style.transition = '';
      });
    } else if (newItem) {
      // Initial open from idle — keep the fade-in
      newItem.classList.add('is-mega-open');
      setExpanded(newItem, true);
      if (header) header.classList.add('has-mega-open');
      document.body.classList.add('has-mega-open');
    }

    activeItem = newItem;
  }

  items.forEach(function (item) {
    const mega = item.querySelector('.mega-menu__content');
    const link = item.querySelector('.header__menu-item');

    item.addEventListener('mouseenter', function (e) {
      hoveredItem = item;
      // Touch (incl. hybrid): the click two-tap owns opening, so a synthetic
      // mouseenter must not pre-open the panel (AAS-4696).
      if (isTouchNav()) return;
      // Already in the menu, so the swap is INSTANT — making the user come to
      // rest again would read as lag rather than as intent. activeItem covers
      // the close hold too: it is only cleared by closeAll, so a cursor that
      // dips out of the nav and back in within CLOSE_DELAY is still the same
      // visit and still opens on contact.
      if (activeItem) {
        setActive(item);
        return;
      }
      // Cold open: wait for the cursor to stop, re-sampling from here so a rest
      // taken on the logo does not count as a rest taken on this item.
      armSettle(e.clientX, e.clientY);
    });
    item.addEventListener('mouseleave', function (e) {
      if (hoveredItem === item) hoveredItem = null;
      if (isTouchNav()) return;
      // Cursor going into our own mega menu — keep open.
      if (mega && mega.contains(e.relatedTarget)) return;
      scheduleClose();
    });

    if (mega) {
      mega.addEventListener('mouseenter', function () {
        if (isTouchNav()) return;
        cancelClose();
      });
      mega.addEventListener('mouseleave', function (e) {
        if (isTouchNav()) return;
        // Cursor going back into our L1 link — keep open.
        if (item.contains(e.relatedTarget)) return;
        scheduleClose();
      });
    }

    // Touch two-tap (AAS-4696): first tap opens THIS L1's mega (navigation
    // suppressed), a second tap on the same L1 follows the link. Mouse and
    // keyboard fall straight through to native nav + the hover/focus handlers.
    if (link) {
      link.addEventListener('click', function (e) {
        if (!isTouchNav()) return;
        if (item === activeItem) {
          // Second tap on the open L1 — let the link navigate.
          closeTapFlyout();
          return;
        }
        // First tap, or a tap on a different L1 while one is open: open this
        // panel and hold navigation. setActive swaps from any prior L1.
        e.preventDefault();
        setActive(item);
        tapOpenItem = item;
      });
    }

    // Keyboard: open on real keyboard focus only. A mouse click on blank space
    // inside the panel also fires focusin (the panel has tabindex="-1"), but is
    // NOT :focus-visible — so clicking never pins the menu open.
    item.addEventListener('focusin', function (e) {
      if (!isKeyboardFocus(e.target)) return;
      setActive(item);
    });

    // Tab out of this L1 entirely (including out of its panel) — close it.
    item.addEventListener('focusout', function (e) {
      if (e.relatedTarget && item.contains(e.relatedTarget)) return;
      scheduleClose();
    });
  });

  function isKeyboardFocus(el) {
    if (!el || typeof el.matches !== 'function') return false;
    try {
      return el.matches(':focus-visible');
    } catch (err) {
      // Browser without :focus-visible — treat any focus as keyboard focus.
      return true;
    }
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && activeItem) closeAll();
  });

  // Outside tap closes a touch-opened panel (AAS-4696). Only fires when a tap
  // pinned one open; a tap inside that L1's own <li> (its label or the mega
  // panel, both children of `item`) keeps it open so category links still
  // navigate. Runs on the same bubbled click that opened the panel, but by then
  // tapOpenItem contains the target, so the first tap survives its own frame.
  document.addEventListener('click', function (e) {
    if (!tapOpenItem) return;
    if (tapOpenItem.contains(e.target)) return;
    closeTapFlyout();
  });

  // A bfcache restore brings the DOM back exactly as it was left, so a panel
  // open at the moment of navigation (the usual case — the link that navigated
  // was inside it) comes back open on arrival, with no cursor near it and no
  // mouseleave coming to close it. The whole JS heap is restored with it, so
  // closeAll() alone would do; the sweep is there for the browsers that restore
  // the document without our timers and state intact. Not gated on
  // e.persisted — on a cold load there is nothing open, so the sweep is a
  // no-op over a handful of <li> — because a restore that did happen has been
  // known to report persisted false. AAS-5658
  window.addEventListener('pageshow', function () {
    cancelSettle();
    cancelClose();
    tapOpenItem = null;
    // Unconditional, not via releaseRestIfIdle: a restore lands with
    // pointerInHeader still true from the click that navigated away (the link
    // was inside the panel, which is inside the header), and there is no
    // mouseleave coming to correct it.
    pointerInHeader = false;
    hoveredItem = null;
    closeAll();
    header.classList.remove(REST_CLASS);
    items.forEach(function (item) {
      item.classList.remove('is-mega-open');
      setExpanded(item, false);
    });
  });
})();
